import React from "react";
import { Navigate } from "react-router-dom";
import api from "../servicios/api";
import { jsonHeaders } from "../servicios/auth";
import logoPMT from "../assets/logo_pmt.png";
import logoMuni from "../assets/logo_muni.png";

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: "",
            password: "",
            mensaje: "",
            logueado: false
        };
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

   iniciarSesion = (e) => {
    e.preventDefault();

fetch(api + "auth/login", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({
        usuario: this.state.usuario,
        password: this.state.password
    })
})
.then(respuesta => respuesta.json())
.then(datos => {

   

    if (datos.success === 1) {

        localStorage.setItem(
            "usuario",
            JSON.stringify(datos.usuario)
        );

       if (datos.usuario && datos.usuario.token) {
             localStorage.setItem("token", datos.usuario.token);
        }

        this.setState({ logueado: true });
        window.location.href = "/inicio";

    } else {

        this.setState({
            mensaje: datos.mensaje || "Usuario o contraseña incorrectos"
        });

    }

})
.catch(error => {

  

    this.setState({
        mensaje: "Error al conectar con el servidor"
    });

});
   }

    render() {
        if (this.state.logueado) {
            return <Navigate to="/inicio" />;
        }

        return (
            <div className="login-page">
                <div className="login-card">
                    
                    <div className="text-center mb-3">

    <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
        <img
            src={logoMuni}
            alt="Logo Municipalidad"
            className="login-logo"
        />

        <img
            src={logoPMT}
            alt="Logo PMT"
            className="login-logo"
        />
    </div>

    <h4 className="mt-2 mb-0">Iniciar sesión</h4>

    <small className="text-muted">
        Sistema de Información PMT Chiantla
    </small>

</div>

                    {this.state.mensaje && (
                        <div className="alert alert-danger py-2">
                            {this.state.mensaje}
                        </div>
                    )}

                    <form onSubmit={this.iniciarSesion}>
                        <div className="mb-3">
                            <label className="form-label">Usuario</label>
                            <input
                                type="text"
                                name="usuario"
                                className="form-control"
                                value={this.state.usuario}
                                onChange={this.cambioValor}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Contraseña</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={this.state.password}
                                onChange={this.cambioValor}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-primary w-100">
                            Entrar
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}

export default Login;